module.exports = require('../_components/@alicd/next-nav/lib/index.js');


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@alicd_next@0.19.78@@alicd/next/lib/nav/index.js
// module id = 256
// module chunks = 0